export const GET_SECTION_INSTRUMENTS = "GET_SECTION_INSTRUMENTS";
export const GET_SECTION_INSTRUMENT_BY_ID = "GET_SECTION_INSTRUMENT_BY_ID";
export const UPDATE_SECTION_INSTRUMENT = "UPDATE_SECTION_INSTRUMENT";
export const DELETE_SECTION_INSTRUMENT = "DELETE_SECTION_INSTRUMENT";
export const CREATE_SECTION_INSTRUMENT = "CREATE_SECTION_INSTRUMENT";
